// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1728px) {
    .scl--jhbs-pad-cons-bo-stl{
        padding-left: var(--global-laptop-padding-left);
        padding-right: var(--global-laptop-padding-left);
    }

    .scl--jdms-bo-con-wid-st{
        padding-left: var(--global-laptop-padding-left);
        padding-right: var(--global-laptop-padding-left);
    }
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/job-detail/css/jobDetailSl.css"],"names":[],"mappings":"AAAA;IACI;QACI,+CAA+C;QAC/C,gDAAgD;IACpD;;IAEA;QACI,+CAA+C;QAC/C,gDAAgD;IACpD;AACJ","sourcesContent":["@media (max-width: 1728px) {\n    .scl--jhbs-pad-cons-bo-stl{\n        padding-left: var(--global-laptop-padding-left);\n        padding-right: var(--global-laptop-padding-left);\n    }\n\n    .scl--jdms-bo-con-wid-st{\n        padding-left: var(--global-laptop-padding-left);\n        padding-right: var(--global-laptop-padding-left);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
